import { NgModule } from '@angular/core';
import { UserSettingsComponent } from './user-settings.component';
import { SharedProviderModule } from '../../shared/shared.module';
import { OverlayPanelModule } from '../overlay-panel/overlay-panel.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    SharedProviderModule,
    OverlayPanelModule,
    NgbTooltipModule
  ],
  declarations: [UserSettingsComponent],
  exports: [UserSettingsComponent],
  providers: []
})
export class UserSettingsModule {
}
